<template>
  <payment-history/>
</template>

<script>
import PaymentHistory from '../components/PaymentHistory/index'
export default {
  components: {PaymentHistory},

}
</script>

<style>

</style>
